import { Component, Input, OnInit } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-monitoring-person',
  templateUrl: './entity-monitoring-person.component.html'
})

export class EntityMonitoringPersonComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Person';

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/entitymonitoringperson/entity-monitoring-person.component.ts